
import { HeroSection } from './components/HeroSection';
import { TechnologySection } from './components/TechnologySection';
import { ProductsSection } from './components/ProductsSection';
import { ResearchSection } from './components/ResearchSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

const HomePage = () => {
  return (
    <main className="min-h-screen">
      <Header />
      <HeroSection />
      <TechnologySection />
      <ProductsSection />
      <ResearchSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default HomePage;
